import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import { msalInstance, msalScopes } from '~config';
import { AuthErrorFallback, initTelemetry } from '~libs';
import App from './App';

initTelemetry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{ scopes: [...msalScopes.login] }}
        errorComponent={AuthErrorFallback}
      >
        <App />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  </StrictMode>,
);
